export default {
    name: "g-button",
    props: {
      cor:{
        type: String,
        default: '#fcb316',
      },
      desabilitado: {
        type: Boolean,
        default: false
      },
      altura: {
        type: String,
        default: '40px'
      },
      tipo: {
        type: String,
        default: 'amarelo'
      },
      icone: {
        type: String,
        default: null
      },
      largura: {
        type: String,
        default: '300px'
      },
      sombreado: {
        type: Boolean,
        default: false
      },
      corTexto: {
        type: String,
        default: '#4f2c19',
      },
      tamanhoTexto: {
        type: String,
        default: '18px'
      },
      minAltura: {
        type: String,
        default: '10px'
      },
      negritoTexto: {
        type: Boolean,
        default: false
      },
      tamanhoIcone: {
        type: String,
        default: '25px'
      },
      somenteIcone: {
        type: Boolean,
        default: false
      },
      corIcone: {
        type: String,
        default: 'black'
      },
      textoFontWeight: {
        type: String,
        default: 'normal'
      },
      bordabotao: {
        type: String,
        default: 'none'
      },
      corbordabotao: {
        type: String,
        default: 'none'
      },
      fontTexto: {
        type: String,
        default: 'system-ui'
      },
      gap: {
        type: String,
        default: '0px'
      },
      corIconeClass: {
        type: String,
        default: '4f2c19' 
      },
      loading: {
        type: Boolean,
        default: false
      }
    },

    created () {
      let tiposValidos = Object.keys(this.tipos)
      if (!tiposValidos.includes(this.tipo)) {
        throw new TypeError(`Tipo de botão não reconhecido: ${this.tipo}. Os tipos validos são: ${tiposValidos}`)
      }
    },

    data() {
      return {
        tipos: {
          vermelho: {
            corDeFundo: '#FF0000',
            corDeTexto: 'white'
          },
          amarelo: {
            corDeFundo: '#fcb316',
            corDeTexto: '#4f2c19'
          },
          cinza: {
            corDeFundo: '#4f2c19',
            corDeTexto: 'white'
          }
        },
        loading: false
      };
    },

    methods: {
      acao () {
        this.$emit('acao')
      },
      isBusy(){
        this.loading = !this.loading
      }
    },
    computed: {
      weightTitulo () {
        return this.negritoTexto ? '500' : this.textoFontWeight
      },
      corDoTexto (){
        if (this.corTexto !== '#4f2c19'){
          return this.corTexto
        }else {
        return this.tipos[this.tipo].corDeTexto
        }
      },
      backgroundColor() {
          if (this.cor !== '#fcb316'){
              return this.cor
          }else {
            return this.tipos[this.tipo].corDeFundo
          }
      },
      isDisabled() {
        return this.desabilitado
      },
      iconeEhSvg() {
        let regexSvg = /.*\.svg/gm
        return regexSvg.test(this.icone)
      },
      // gap(){
      //   return this.somenteIcone ? '0px':'10px'
      // }
    }

  };
